var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Small/CaretDown",
    transform: "scale(1, -1) translate(0, -19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.14246 11.455L9.07996 5.51746C9.1351 5.46225 9.20059 5.41846 9.27267 5.38858C9.34475 5.3587 9.42201 5.34332 9.50004 5.34332C9.57806 5.34332 9.65533 5.3587 9.72741 5.38858C9.79949 5.41846 9.86497 5.46225 9.92011 5.51746L15.8576 11.455C15.969 11.5664 16.0316 11.7175 16.0316 11.875C16.0316 12.0326 15.969 12.1837 15.8576 12.2951C15.7462 12.4065 15.5951 12.4691 15.4375 12.4691C15.28 12.4691 15.1289 12.4065 15.0175 12.2951L9.50004 6.77695L3.98261 12.2951C3.92745 12.3503 3.86196 12.394 3.78988 12.4239C3.7178 12.4538 3.64055 12.4691 3.56254 12.4691C3.48452 12.4691 3.40727 12.4538 3.33519 12.4239C3.26311 12.394 3.19762 12.3503 3.14246 12.2951C3.08729 12.2399 3.04353 12.1745 3.01368 12.1024C2.98382 12.0303 2.96846 11.9531 2.96845 11.875C2.96846 11.797 2.98382 11.7198 3.01368 11.6477C3.04353 11.5756 3.08729 11.5101 3.14246 11.455Z",
    fill: "#343330"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/ExpandMore.7e166fd0f1f4a2aba4cff7d2308a5441.svg";
export { ForwardRef as ReactComponent };